import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ic-close-red-sharp_e98844c5e79f2b4b9ba68f92027c8852",
  "use": "ic-close-red-sharp_e98844c5e79f2b4b9ba68f92027c8852-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"ic-close-red-sharp_e98844c5e79f2b4b9ba68f92027c8852\">\n<path d=\"M38 12.82L35.18 10L24 21.18L12.82 10L10 12.82L21.18 24L10 35.18L12.82 38L24 26.82L35.18 38L38 35.18L26.82 24L38 12.82Z\" fill=\"#C90000\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol